import React, { useRef, useState, useEffect } from "react";

interface EditableResultProps {
  text: string;
  onChange: (text: string) => void;
}

export function EditableResult({ text, onChange }: EditableResultProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [editing, setEditing] = useState(false);
  const [edited, setEdited] = useState(false);

  useEffect(() => {
    setEditing(false);
    setEdited(false);
    if (ref.current) ref.current.innerText = text;
  }, [text]);

  const handleInput = () => {
    if (ref.current) {
      const t = ref.current.innerText;
      if (t !== text) { setEdited(true); onChange(t); }
    }
  };

  return (
    <div className="relative">
      <div className="flex items-center justify-between px-4.5 mb-0.5">
        <button
          onClick={() => { setEditing((e) => !e); if (!editing && ref.current) ref.current.focus(); }}
          className={`text-sm tracking-[1px] bg-transparent rounded-sm px-2.5 py-1 cursor-pointer font-sans
                      transition-all duration-200 flex items-center gap-1.5 border
                      ${editing ? "text-accent border-accent/30" : "text-tertiary border-transparent"}`}
        >
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M7.5 1.5l2 2M1 7.5L7.5 1.5l2 2L3.5 10H1V7.5z" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {editing ? "Mode édition actif" : "Cliquer pour éditer le texte"}
        </button>
        {edited && <span className="text-sm text-success italic">Modifié</span>}
      </div>
      <div
        ref={ref}
        contentEditable={editing}
        suppressContentEditableWarning
        onInput={handleInput}
        onFocus={() => setEditing(true)}
        onBlur={handleInput}
        className={`px-4.5 pt-4.5 pb-5 text-md leading-[1.9] text-foreground/85 whitespace-pre-wrap
                    font-light outline-none rounded transition-all duration-200 min-h-[60px]
                    ${editing
                      ? "cursor-text bg-accent/[0.03] border border-dashed border-accent/20"
                      : "cursor-pointer bg-transparent border border-dashed border-transparent"}`}
      />
    </div>
  );
}
